import React from "react";
import { SITE } from "../content";
import { Breadcrumbs } from "../components/Layout";
import { Reveal } from "../components/Motion";
import { GangArt } from "../components/Art";

const STEPS = [
  {
    html: (
      <>
        Datang ke kawasan <strong>Pasar Baru</strong>, Sawah Besar, Jakarta Pusat — kawasan belanja
        di sisi timur Sungai Ciliwung kecil.
      </>
    ),
  },
  {
    html: (
      <>
        Dari jalan utama Pasar Baru, masuk ke <strong>Gang Kelinci</strong> (dikenal juga sebagai
        Jalan Belakang Kongsi).
      </>
    ),
  },
  {
    html: (
      <>
        Berjalanlah menyusuri gang sampai <strong>hampir ke ujungnya</strong> — kedai kami berada di
        nomor 16, di dalam gang yang sama dengan kedai bakmi lainnya.
      </>
    ),
  },
  {
    html: (
      <>
        Akhir pekan biasanya ramai. <strong>Datang lebih awal</strong> untuk menghindari antre.
      </>
    ),
  },
];

export default function LokasiPage() {
  return (
    <>
      <section className="page-head" data-testid="lokasi-head">
        <Breadcrumbs current="Lokasi" />
        <h1 className="page-head__title">Temukan kami di Gang Kelinci</h1>
        <p className="page-head__lede">
          Kedai kami berada di dalam gang kecil di Pasar Baru — sedikit tersembunyi, tetapi selalu
          dicari.
        </p>
      </section>

      <section className="section">
        <div className="info-grid">
          <Reveal className="info-card">
            <p className="info-card__label">Alamat</p>
            <p className="info-card__value">{SITE.address.street}</p>
            <p className="info-card__sub">
              {SITE.address.area}, {SITE.address.city}, {SITE.address.region}
            </p>
          </Reveal>
          <Reveal className="info-card" delay={0.08}>
            <p className="info-card__label">Jam Buka</p>
            <p className="info-card__value">10.00–22.00 WIB</p>
            <p className="info-card__sub">Setiap hari, Senin sampai Minggu</p>
          </Reveal>
          <Reveal className="info-card" delay={0.16}>
            <p className="info-card__label">Peta</p>
            <a
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="info-card__value"
              data-testid="lokasi-cta-maps"
            >
              Buka di Google Maps ↗
            </a>
            <p className="info-card__sub">Cari “Bakmi Aboen, Pasar Baru”</p>
          </Reveal>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <Reveal className="section__head">
          <p className="section__eyebrow">Cara ke Sini</p>
          <h2 className="section__title">Menyusuri gang sampai hampir ke ujung</h2>
        </Reveal>
        <div className="steps">
          {STEPS.map((s, i) => (
            <Reveal className="step" key={i} delay={i * 0.05}>
              <p>{s.html}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section band">
        <Reveal>
          <h2 className="band__address">Sampai jumpa di ujung gang.</h2>
          <div className="band__ctas">
            <a
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--seal"
              data-testid="lokasi-cta-petunjuk"
            >
              Petunjuk Arah <span className="btn__arrow">↗</span>
            </a>
          </div>
          <GangArt className="band__art" />
        </Reveal>
      </section>
    </>
  );
}
